
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 70 70","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M56.07 12.11c-3.465 0-6.3 2.66-6.58 6.055H8.855c-.875 0-1.575.7-1.575 1.575v36.61c0 .875.7 1.54 1.575 1.54h47.6c3.395 0 6.195-2.765 6.195-6.195V18.69c.035-3.64-2.94-6.58-6.58-6.58zm.42 43.12H10.01V20.825h39.48v4.55H14.035V35.84h2.66v-7.805h17.99v6.685h4.655v-3.255h-1.96v-3.43h12.11V31.5h-6.58v3.115h6.58V47.53h-9.415v-6.79h2.8v-2.31h-8.26v2.31h2.8v6.79h-14.14v-6.79h8.505v-2.31H20.615v9.065h-3.92V38.43h-2.66v11.76H49.49v1.4c0 .77.63 1.365 1.4 1.365.77 0 1.4-.63 1.4-1.365 0-2.1 1.715-3.815 3.815-3.815 2.1 0 3.815 1.715 3.815 3.815 0 .14.035.315.07.455-.175 1.785-1.68 3.185-3.5 3.185z","fill":"#27AE60"}})])
          )
        }
      }
    